import { render, staticRenderFns } from "./importChannelCompany.vue?vue&type=template&id=2cc91e24&scoped=true"
import script from "./importChannelCompany.vue?vue&type=script&lang=js"
export * from "./importChannelCompany.vue?vue&type=script&lang=js"
import style0 from "./importChannelCompany.vue?vue&type=style&index=0&id=2cc91e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc91e24",
  null
  
)

export default component.exports